import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabPanel = _resolveComponent("TabPanel")!

  return (_openBlock(), _createBlock(_component_TabPanel, _normalizeProps(_guardReactiveProps({ ..._ctx.$props, ..._ctx.$attrs })), {
    default: _withCtx(({ selected }) => [
      _renderSlot(_ctx.$slots, "default", { selected: selected })
    ]),
    _: 3
  }, 16))
}